import { isEmpty } from 'lodash'

export default function checkIfProductIsReady(product) {
  if (
    product.name 
      && product.chName
      && product.address
      && (product.subtitle || product.tags["2sn6dbecc3"]) // Miramos si es restaurante
      && product.timetable && (!isEmpty(product.timetable.schedules) || !isEmpty(product.timetable.exceptions))
      && product.background
      && product.background.image 
      && product.foreground
      && product.foreground.image 
      && product.description 
      && product.preciseLocation
      && product.preciseLocation.latitude 
      && product.preciseLocation.longitude 
  ) {
    return true
  } 
  else return false
}